<template>
    <StripeCheckout>
        <template v-slot:meta>
			<v-col cols="12">
				<v-text-field v-model="mValue.title" label="Title" />
			</v-col>
			<v-col cols="12">
				<p class="editor-label">Description</p>
				<text-editor class="mb-2" v-model="mValue.text" />
			</v-col>
        </template>

        <template v-slot:Checkout>
			<v-col cols="12" class="checkout-section">
				<v-checkbox v-model="mValue.includeCheckout" label="Include 'Stripe Checkout'" />
			</v-col>
			<template v-if="mValue.includeCheckout">
				<v-col cols="12">
					<p class="editor-label">'Checkout' Description</p>
					<text-editor class="mb-2" v-model="mValue.checkoutDescription" />
				</v-col>
				<v-col cols="12">
					<v-text-field v-model="mValue.ctaButtonLabel" label="CTA Button Label" />
				</v-col>
				<v-col cols="12" sm="3">
					<v-select :items="modeOptions" v-model="mValue.mode" label="Mode" />
				</v-col>
				<v-col cols="12" sm="9">
					<v-text-field v-model="mValue.return_url" label="Return Url" />
				</v-col>
				<v-col>
					<v-card cols="12" v-for="(item, index) in mValue.line_items" :key="index">
						<v-card-text class="d-flex align-center">
							<v-row>
								<v-col cols="12" sm="9">
									<v-text-field v-model="item.product_id" label="Product Id" />
								</v-col>
								<v-col cols="12" sm="3">
									<v-text-field v-model.number="item.quantity" label="Quantity" />
								</v-col>
							</v-row>
							<v-btn class="ml-2" fab small color="red" :disabled="mValue.line_items.length === 1" @click="removeProduct(index)">
								<v-icon small>fas fa-trash</v-icon>
							</v-btn>
						</v-card-text>
					</v-card>
					<div class="text-right">
						<v-btn color="primary" @click="addProduct">Add Product</v-btn>
					</div>
				</v-col>
			</template>
        </template>

		<template v-slot:CheckoutReturn>
			<v-col cols="12" class="checkout-return-section mt-6">
				<v-checkbox v-model="mValue.includeCheckoutReturn" label="Include 'Stripe Checkout Return'" />
			</v-col>
			<template v-if="mValue.includeCheckoutReturn">
				<v-col cols="12">
					<p class="editor-label">'Checkout Return' Description</p>
					<text-editor class="mb-2" v-model="mValue.checkoutReturnDescription" />
				</v-col>
				<v-col cols="12">
					<p class="editor-label">Text when 'Return Status' is 'complete'</p>
					<text-editor v-model="mValue.completeStatusText" />
				</v-col>
				<v-col cols="12">
					<p class="editor-label">Text when 'Return Status' is not 'complete'</p>
					<text-editor v-model="mValue.incompleteStatusText" />
				</v-col>
				<v-col cols="12" sm="5">
					<v-checkbox v-model="mValue.includeTryAgainButton" label="Include 'Try Checkout Again' Button" />
				</v-col>
				<v-col cols="12" sm="7" v-if="mValue.includeTryAgainButton">
					<v-text-field v-model="mValue.tryAgainButtonLabel" label="'Try Checkout Again' Button Label" />
				</v-col>
			</template>
        </template>
    </StripeCheckout>
</template>

<script>
import TextEditor from '@/CMS/editor/components/TextEditor.vue'
import StripeCheckout from '@/CMS/views/ContentBlocks/StripeCheckout.vue'

export default {
    name: 'StripeCheckoutEditor',
    components: {
        StripeCheckout,
		TextEditor,
    },
   	props: {
		value: { type: Object },
	},
    data () {
        return {
			modeOptions: ['payment', 'subscription', 'setup'],
			counter: Math.floor(Math.random() * 1000000000),
        }
    },
    created () {
        this.reset()
    },
	computed: {
		mValue: {
			get () { return this.value },
			set (val) { this.$emit('input', val) },
		},
	},
    methods: {
        reset () {
			const value = this.value || {}
			const newItem = this.getNewItem()
			const item = Object.keys(newItem).reduce((acc, key) => {
				if (typeof value[key] === 'undefined') {
					acc[key] = newItem[key]
				}
				return acc
			}, {})
			this.mValue = {
				...value,
				...item,
			}
		},
		getNewItem () {
			this.counter = this.counter + 1
			return {
				id: this.counter,
				title: undefined,
				text: undefined,

				includeCheckout: false,
				checkoutDescription: undefined,
				ctaButtonLabel: 'Initiate a payment',
				mode: undefined,
				line_items: [{ product_id: undefined, quantity: 1 }],
				return_url: undefined,

				includeCheckoutReturn: false,
				checkoutReturnDescription: undefined,
				completeStatusText: undefined,
				incompleteStatusText: undefined,
				includeTryAgainButton: false,
				tryAgainButtonLabel: 'Try a payment again',
			}
		},
		addProduct () {
			this.mValue.line_items = [
				...this.mValue.line_items,
				{ product_id: undefined, quantity: 1 },
			]
		},
		removeProduct (index) {
			this.mValue.line_items = [
				...this.mValue.line_items.slice(0, index),
				...this.mValue.line_items.slice(index + 1),
			]
		},
    },
}
</script>

<style lang="scss" scoped>
.editor-label {
	font-size: 13.5px;
	font-weight: 300;
	margin-bottom: 0 !important;
}

.checkout-section {
	background-color: #F1F1F1;
}

.checkout-return-section {
	background-color: #F1F1F1;
}
</style>
